import { useLayoutEffect, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

export interface DOMRectReadOnlyWithoutToJSON extends Omit<DOMRectReadOnly, 'toJSON'> {}

export default (): [
  DOMRectReadOnlyWithoutToJSON,
  (element: Element | null) => void,
] => {
  const [node, setNode] = useState<Element | null>(null);
  const [size, setSize] = useState<DOMRectReadOnlyWithoutToJSON>({
    bottom: 0,
    height: 0,
    left: 0,
    right: 0,
    top: 0,
    width: 0,
    x: 0,
    y: 0,
  });

  useLayoutEffect(() => {
    const observer = new ResizeObserver(([entry]) => {
      if (entry) {
        setSize(entry.contentRect);
      }
    });

    if (node) {
      observer.observe(node);
    }

    return () => {
      if (node) {
        observer.unobserve(node);
      }

      observer.disconnect();
    };
  }, [node]);

  return [size, setNode];
};
